import { Hint } from '@/Ship/Components/Hint'

import { DictionaryStatusTag } from './DictionaryStatusTag'

export interface OfferedPriceHintProps {
    /** Довідник статусів власника (`Setting.ListRequestStatus`, `Setting.ListTenderStatus`) */
    statusResource: string
    /** Коди «Ціну запропоновано» й «Новий» власника */
    codes: { price: string; new: string }
    /** Іменник у реченні: «новий запит» / «закритому запиті», «новий тендер» / «закритому тендері» */
    subject: { new: string; closed: string }
}

/**
 * Підказка над «Запропонованою ціною» (`SPEC-022` §12, `SPEC-023` §4.5): одна
 * на запит і тендер — правило ціни в них одне, тож і `id` один, і «більше не
 * показувати» гасить її в обох картках. Тому вона тут, а не в шаблоні кожного
 * власника: два `<Hint>` з одним `id` вартовий унікальності підказок не пускає.
 */
export const OfferedPriceHint = ({ statusResource, codes, subject }: OfferedPriceHintProps) => (
    <Hint id="transport.request.offered-price">
        Ціна більша за нуль переводить {subject.new} у статус{' '}
        <DictionaryStatusTag resource={statusResource} code={codes.price} />; нульова — повертає в{' '}
        <DictionaryStatusTag resource={statusResource} code={codes.new} />. У {subject.closed} статус від ціни не
        змінюється.
    </Hint>
)
